import { useLinkLikeClick } from '../../../../../../hooks'
import { getApplicantProfileLink } from '../../../../../RentalPortalApplicant'
import { useRentalPortalViewingApplicantPreview } from '../../../../RentalPortalViewingApplicantPreviewModal'
import { useViewingProfileContext } from '../../../RentalPortalViewingProfile.hooks'

export function useViewingProfileHeaderInfoItems({ isPreview }) {
  const { handleCloseModal, setModal, viewingData } = useViewingProfileContext()

  const { handleOpenApplicantPreview } = useRentalPortalViewingApplicantPreview(
    { setModal, onClose: handleCloseModal }
  )

  const { handleClick } = useLinkLikeClick()

  function handleClickApplicant() {
    if (isPreview) {
      handleOpenApplicantPreview(viewingData)
    } else {
      handleClick({ link: getApplicantProfileLink(viewingData.applicant.id) })
    }
  }

  function handleClickApplicantItem(item) {
    handleClick({ link: getApplicantProfileLink(item.id) })
  }

  return { handleClickApplicant, handleClickApplicantItem }
}
